import axios from 'axios';

import { parseResponse, handleError } from '@/_helpers/utils.js';

const state = {
  loading: true,
  error: null,
  company: null,
  is_import_opened: false
};

const actions = {
  fetch({ commit, dispatch }, id) {
    commit('fetch');

    return axios
      .get(`/1.0/admin/companies/${id}`)
      .then(response => {
        const data = parseResponse(response);
        commit('fetchSuccess', { data: data.data, meta: data.meta });
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, { root: true });
        commit('fetchFailure', error);
      });
  },

  update({ commit, dispatch }, model) {
    commit('update');

    return axios
      .put('/1.0/admin/companies', {
        companies: [model]
      })
      .then(response => {
        const data = parseResponse(response);

        commit('update_success', { data: data.data, meta: data.meta });
      })
      .catch(err => {
        const error = handleError(err);

        dispatch('global/setError', error, { root: true });
        commit('update_failure', error);
        return Promise.reject(error);
      });
  }
};

const mutations = {
  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, { data }) {
    state.company = data[0] ? data[0] : null;
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
    // console.error(err);
  },

  update(state) {
    state.loading = true;
  },

  update_success(state, { data }) {
    state.company = data[0] ? data[0] : null;
    state.loading = false;
  },

  update_failure(state, err) {
    state.error = err;
    state.loading = false;
    // console.error(err)
  },

  set_import_opened(state) {
    state.is_import_opened = true;
  },

  clear(state) {
    state.company = null;
  }
};

const getters = {
  loading: state => {
    return state.loading;
  },

  one: state => {
    return state.company;
  },

  is_import_opened: state => {
    return state.is_import_opened;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
